<div class="concentraiondetectiontab wrap">

  <div id="leftPanel" class="leftPanel">
    <p-fieldset legend="Concentration Detection">
      <form [formGroup]="concentrationDetectionForm">
        <div class="ui-g ui-fluid centered">

          <div class="ui-g-12 ui-md-6">
            <div class="ui-inputgroup">
              <button style="width: 105px;" pButton class="theme-button noHover" type="button" label="PUID"></button>
              <input type="text" autofocus autocomplete="off" id="createdby" formControlName="createdBy"
                placeholder="PUID" [(ngModel)]="createdBy" (keydown.enter)="focusMachinebarcode()">
            </div>
          </div>

          <div class="ui-g-12 ui-md-6">
            <div class="ui-inputgroup" style="margin-left: 32px;">
              <button pButton class="theme-button noHover" type="button" label="Machine"></button>
              <input style="width: 130px;" type="text" autocomplete="off" id="machinbarcode"
                formControlName="machineBarcode" placeholder="Barcode" [(ngModel)]="machineBarcode">
            </div>
          </div>

          <div class="ui-g-12 ui-md-6">
            <div class="ui-inputgroup">
              <button pButton class="theme-button noHover" type="button" #filePicker="ngxFilePicker"
              ngxFilePicker [readMode]="readMode"   accept="*/*" (filePick)="onLrsFilePicked($event)"
                (readEnd)="onLrsFileReadEnd($event)" label="Choose File"></button>
              <input type="text" autofocus autocomplete="off" id="pickedLrsFileName" formControlName="lrsFileName"
                placeholder="Upload hamilton file" [(ngModel)]="lrsFileName">
            </div>
          </div>

          <div class="ui-g-12 ui-md-6">
            <div class="ui-inputgroup" style="margin-left: 32px;">
              <button style="width: 217px;" pButton class="theme-button noHover" type="button"
                label="View Concentrations" [disabled]="!concentrationDetectionForm.valid"
                (click)="uploadHemiltonFile()"></button>
            </div>
          </div>

        </div>
      </form>
    </p-fieldset>

    <br>

    <div *ngIf="fragmentAnalysisArray !== undefined">
      <h6 class="pb-2 mb-0">Select Assay Type :
        <button style="width: 200px;" pButton class="theme-button noHover" (click)="refreshAssyTypeTable()"
            type="button" label="Apply AssayType Changes" style="float: right;" class="icon-refresh"></button>
      </h6>
      <table class="table table-hover table-bordered" aria-describedby="Fragment Analysis">
        <thead>
          <tr style="background-color: #DFE7F0">
            <th scope="col">Select</th>
            <th scope="col">Assay Type</th>
            <th scope="col">Samples</th>
            <th scope="col">a</th>
            <th scope="col">b</th>
            <th scope="col">c</th>
          </tr>
        </thead>
        <tbody>

          <!-- Assay-Type : HS_Large_Fragment -->
          <tr style="background-color: #C0E0F9">
            <td>
              <input name="ASSAY_TYPE" value="HS_LARGE_FRAGMENT" type="radio"
                [disabled]="selectAssayTypeBtnDisabled(totalNoOfSampleForHS_Large)"
                (click)="selectAssayType('HS_LARGE_FRAGMENT')" />
            </td>
            <td>
              HS Large Fragment
            </td>
            <td>
              {{totalNoOfSampleForHS_Large}}
            </td>
            <td>
              <div>
                {{cat_a1}}
              </div>
            </td>
            <td>
              <div>
                {{cat_b1}}
              </div>
            </td>
            <td>
              <div>
                {{cat_c1}}
              </div>
            </td>
          </tr>

          <!-- Assay-Type : HS_NGS_Fragment 9CD1FC-->
          <tr style="background-color: rgb(126, 193, 248)">
            <td>
              <input name="ASSAY_TYPE" value="HS_NGS_FRAGMENT" type="radio"
                [disabled]="selectAssayTypeBtnDisabled(totalNoOfSampleForHS_NGS)"
                (click)="selectAssayType('HS_NGS_FRAGMENT')" />
            </td>
            <td>
              HS NGS Fragment
            </td>
            <td>
              {{totalNoOfSampleForHS_NGS}}
            </td>
            <td>
              <div>
                {{cat_a2}}
              </div>
            </td>
            <td>
              <div>
                {{cat_b2}}
              </div>
            </td>
            <td>
              <div>
                {{cat_c2}}
              </div>
            </td>
          </tr>

          <!-- Assay-Type : SS_NGS_Fragment  A4CEDB-->
          <tr style="background-color: rgb(88, 168, 192)">
            <td>
              <input name="ASSAY_TYPE" value="SS_NGS_FRAGMENT" type="radio"
                [disabled]="selectAssayTypeBtnDisabled(totalNoOfSampleForSS_NGS)"
                (click)="selectAssayType('SS_NGS_FRAGMENT')" />
            </td>
            <td>
              SS NGS Fragment
            </td>
            <td>
              {{totalNoOfSampleForSS_NGS}}
            </td>
            <td>-</td>
            <td>
              <div>
                {{cat_b3}}
              </div>
            </td>
            <td>
              <div>
                {{cat_c3}}
              </div>
          </tr>

          <!-- Assay-Type : NO ASSAY TYPE -->
          <tr style="background-color: #C3D5DB">
            <td>
              <input name="ASSAY_TYPE" type="radio" [disabled]="true" />
            </td>
            <td>
              No Assay Type
            </td>
            <td>
              {{fragmentAnalysisNOAssay?.length}}
            </td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
          </tr>

        </tbody>
      </table>

      <div class="row">
        <div class="col-md-8">
          <p-fieldset legend="Generate workfile">

            <form [formGroup]="generareWorkFileForm">
              <div class="ui-g ui-fluid centered">

                <div class="ui-g-12 ui-md-8">
                  <div class="ui-inputgroup">
                    <button style="width: 105px;" pButton class="theme-button noHover" type="button"
                      label="FA Plate"></button>
                    <input type="text" autofocus autocomplete="off" id="createdby" [(ngModel)]="faPlateBarcode"
                      placeholder="Plate barcode" formControlName="faPlateBarcode">
                  </div>
                </div>

                <div class="ui-g-12 ui-md-4">
                  <div class="ui-inputgroup" style="margin-left: 32px;">
                    <button style="width: 217px;" pButton class="theme-button noHover" type="button"
                      label="Create FA Workfiles" [disabled]="!generareWorkFileForm.valid"
                      (click)="generateWorkFile()"></button>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-6">
                  <input type="radio" formControlName="machineType" value="JEKYLL"
                    (change)="onMachineTypeChange('JEKYLL')" />
                  Jekyll (12-Capillary Array)
                  <br />
                  <input type="radio" formControlName="machineType" value="HYDE"
                    (change)="onMachineTypeChange('HYDE')" />
                  Hyde (48-Capillary Array)
                  <br />
                  <input type="radio" formControlName="machineType" value="FAUST"
                    (change)="onMachineTypeChange('FAUST')" />
                    Dr.Faust (96-Capillary Array)
                </div>

              </div>
            </form>
          </p-fieldset>

        </div>
        <div class="workfilewidth col-md-4">
          <div>
            <p>Available Plates:</p>
          </div>
          <div class="available-plate-data-div tableFixHead">
            <table class="table table-hover table-bordered" aria-describedby="Fa-Plates" *ngIf="faPlates != null && faPlates.length != 0">
              <thead class="fixed_header">
                <tr>
                  <th scope="col" style="text-align: center;">Barcode</th>
                  <th scope="col" style="text-align: center;">Pos</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of faPlates">
                  <td>{{item.barcode}}</td>
                  <td>{{item.availablePositions}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

  </div>


  <div id="rightPanel" class="rightPanel">

    <div *ngIf="fragmentAnalysisArray !== undefined" class="table-data-div">

      <table class="table table-striped table-bordered" data-vertable="ver5" id="liquidLevelDetectionTable" aria-describedby="Hamilton Rack View">

        <thead>
          <tr style="background-color: rgba(219, 225, 240, 0.747)">
            <th scope="col" style="text-align: center;">Position</th>
            <th scope="col" *ngFor="let head of fragmentAnalysisRackUnique">
              {{head.carrierBarcode}}<br>{{head.rackPosition}}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of tableRows; let i = index;">
            <td style="text-align: center;">{{row}}</td>

            <!-- Rack 1 Column -->
            <td *ngIf="fragmentAnalysisRack1.length" [className]="boxHighlighting(fragmentAnalysisRack1[i])">

              <!-- To show barcodes -->
              <div [title]="fragmentAnalysisRack1[i]?.sampleBarcode ? 'Sample barcode' : 'Sample not found'"
                [className]="isBarcodeFound(fragmentAnalysisRack1[i]) ? 'barcodeFound' : 'barcodeNotFound'"
                [style.color]="!isSampleActive(fragmentAnalysisRack1[i]) ? '#8c8c83':'' ">
                <div>
                  <input [hidden]="!isBarcodeFound(fragmentAnalysisRack1[i])" [checked]="!isSampleActive(fragmentAnalysisRack1[i])"
                  (click)="onCheckBoxClick($event, fragmentAnalysisRack1[i])" type="checkbox" />
                  {{fragmentAnalysisRack1[i]?.sampleBarcode? fragmentAnalysisRack1[i]?.sampleBarcode: "-"}}
                </div>
                    </div>

              <!-- Sample concentration -->
              <div title="Sample concentration" [className]="textColor(fragmentAnalysisRack1[i])">
                {{fragmentAnalysisRack1[i]?.concentrationValue? (roundOfDecimal(fragmentAnalysisRack1[i]?.concentrationValue)): "-"}}
                ng/&#181;l
              </div>
               <!-- To show sample assayType  -->
              <div [hidden]="!fragmentAnalysisRack1[i]?.concentrationValue" >
                <select [disabled]="!isSampleActive(fragmentAnalysisRack1[i])" (change)="onAssayTypeChange(fragmentAnalysisRack1[i], $event.target.value)">
                  <option *ngFor= "let assayType of listAssayType" [disabled]="disableAssayTypeOptions(fragmentAnalysisRack1[i], assayType)" [selected]="assayType===getAssayTypeforSample(fragmentAnalysisRack1[i])">
                      {{assayType}}
                  </option>
                </select>
              </div>
            </td>

            <!-- Rack 2 Column -->
            <td *ngIf="fragmentAnalysisRack2.length" [className]="boxHighlighting(fragmentAnalysisRack2[i])">
              <!-- To show barcodes -->
              <div [title]="fragmentAnalysisRack2[i]?.sampleBarcode ? 'Sample barcode' : 'Sample not found'"
                [className]="isBarcodeFound(fragmentAnalysisRack2[i]) ? 'barcodeFound' : 'barcodeNotFound'"
                [style.color]="!isSampleActive(fragmentAnalysisRack2[i]) ? '#8c8c83':'' ">
                <div>
                  <input [hidden]="!isBarcodeFound(fragmentAnalysisRack2[i])" [checked]="!isSampleActive(fragmentAnalysisRack2[i])"
                  (click)="onCheckBoxClick($event, fragmentAnalysisRack2[i])" type="checkbox" />
                  {{fragmentAnalysisRack2[i]?.sampleBarcode? fragmentAnalysisRack2[i]?.sampleBarcode: "-"}}
                </div>
              </div>

              <!-- Sample concentration -->
              <div title="Sample concentration" [className]="textColor(fragmentAnalysisRack2[i])">
                {{fragmentAnalysisRack2[i]?.concentrationValue? (roundOfDecimal(fragmentAnalysisRack2[i]?.concentrationValue)): "-" }}
                ng/&#181;l
              </div>
              <!-- To show sample assayType  -->
              <div [hidden]="!fragmentAnalysisRack2[i]?.concentrationValue">
                <select [disabled]="!isSampleActive(fragmentAnalysisRack2[i])" (change)="onAssayTypeChange(fragmentAnalysisRack2[i], $event.target.value)">
                  <option *ngFor= "let assayType of listAssayType" [disabled]="disableAssayTypeOptions(fragmentAnalysisRack2[i], assayType)" [selected]="assayType===getAssayTypeforSample(fragmentAnalysisRack2[i])">
                      {{assayType}}
                  </option>
                </select>
              </div>
            </td>

            <!-- Rack 3 Column -->
            <td *ngIf="fragmentAnalysisRack3.length" [className]="boxHighlighting(fragmentAnalysisRack3[i])">
              <!-- To show barcodes -->
              <div [title]="fragmentAnalysisRack3[i]?.sampleBarcode ? 'Sample barcode' : 'Sample not found'"
                [className]="isBarcodeFound(fragmentAnalysisRack3[i]) ? 'barcodeFound' : 'barcodeNotFound'"
                [style.color]="!isSampleActive(fragmentAnalysisRack3[i]) ? '#8c8c83':'' ">
                <div>
                  <input [hidden]="!isBarcodeFound(fragmentAnalysisRack3[i])" [checked]="!isSampleActive(fragmentAnalysisRack3[i])"
                  (click)="onCheckBoxClick($event, fragmentAnalysisRack3[i])" type="checkbox" />
                  {{fragmentAnalysisRack3[i]?.sampleBarcode? fragmentAnalysisRack3[i]?.sampleBarcode: "-"}}
                </div>
              </div>

              <!-- Sample concentration -->
              <div title="Sample concentration" [className]="textColor(fragmentAnalysisRack3[i])">
                {{fragmentAnalysisRack3[i]?.concentrationValue? (roundOfDecimal(fragmentAnalysisRack3[i]?.concentrationValue)): "-" }}
                ng/&#181;l
              </div>
               <!-- To show sample assayType  -->
               <div [hidden]="!fragmentAnalysisRack3[i]?.concentrationValue">
                <select [disabled]="!isSampleActive(fragmentAnalysisRack3[i])" (change)="onAssayTypeChange(fragmentAnalysisRack3[i], $event.target.value)">
                  <option *ngFor= "let assayType of listAssayType" [disabled]="disableAssayTypeOptions(fragmentAnalysisRack3[i], assayType)" [selected]="assayType===getAssayTypeforSample(fragmentAnalysisRack3[i])">
                      {{assayType}}
                  </option>
                </select>
              </div>
            </td>

          </tr>

        </tbody>
      </table>
    </div>
  </div>

</div>
